import { t } from 'i18next'
import React, { useContext, useState } from 'react'
import { ButtonBlue } from '../../components/Buttons/ButtonBlue'
import { CustomAlert } from '../../components/CustomAlert/CustomAlert';
import LoginContext from '../../context/LoginContext/LoginContext';
import { validateEmail } from '../../helpers/helpers';
import { Spinner } from 'reactstrap';

export const RecoverPassword = () => {

    const { loginState, sendResetPassword } = useContext(LoginContext);
    const { forgotPassword } = loginState;

    const initialState = {
        mail: '',
        user_name: ''
    };

    const [user, setUser] = useState(initialState);

    const disabled = !!!user.user_name.trim() || !!!user.mail.trim() || !!!validateEmail(user.mail);

    const handleChange = (e) => {
        const { value, name } = e.target;
        setUser({
            ...user,
            [name]: value
        })
    }

    const handleSendMail = (e) => {
        e.preventDefault();
        if (disabled) return
        sendResetPassword(user)
    }

    return (
        <div className='pe-4 ps-4'>
            <h4 className='m-0 custom h3'>
                {t('ENTER_MAIL_AND_USER_TO_RESET')}
            </h4>
            <form className='d-flex flex-column mt-4 gap-4' onSubmit={handleSendMail}>
                {forgotPassword.error ? <CustomAlert text={forgotPassword.message} color={'danger'} /> : null}
                <div>
                    <label
                        htmlFor="email"
                        className="form-label blue-dark-text"
                    >
                        {t('EMAIL')}
                    </label>
                    <input
                        placeholder={t('ENTER_MAIL')}
                        type="email"
                        name="mail"
                        value={user.mail}
                        className="form-control"
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <label
                        htmlFor="user_name"
                        className="form-label blue-dark-text"
                    >
                        {t('USER_NAME')}
                    </label>
                    <input
                        placeholder={t('ENTER_USER_NAME')}
                        type="text"
                        name="user_name"
                        value={user.user_name}
                        className="form-control"
                        onChange={handleChange}
                    />
                </div>

                {
                    forgotPassword.isFetching ?
                        <div className="d-flex mt-4 justify-content-center">
                            <Spinner />
                        </div>
                        :
                        <ButtonBlue
                            className='w-100'
                            type='submit'
                            disabled={disabled}
                        >
                            {t('SEND')}
                        </ButtonBlue>
                }
            </form>
        </div>
    )
}
